'use client';

import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Search } from 'lucide-react';
import {
  SortOption,
  type FilterOption,
  getSortLabel,
} from '@/types/tournament.model';
import { Gender } from '@/types';
import { getGenderLabel } from '@/utils/gender-utils';

interface SearchAndFiltersProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  genderFilter: FilterOption;
  setGenderFilter: (filter: FilterOption) => void;
  sortBy: SortOption;
  setSortBy: (sort: SortOption) => void;
  hideGenderFilter?: boolean;
}

export function SearchAndFilters({
  searchQuery,
  setSearchQuery,
  genderFilter,
  setGenderFilter,
  sortBy,
  setSortBy,
  hideGenderFilter = false,
}: SearchAndFiltersProps) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
      {/* Search Input */}
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
        <Input
          placeholder="Buscar por nombre o email..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="pl-10"
        />
      </div>

      {/* Gender Filter */}
      {!hideGenderFilter && (
        <Select value={genderFilter} onValueChange={setGenderFilter}>
          <SelectTrigger className="w-full sm:w-[180px]">
            <SelectValue placeholder="Filtrar por género" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos los géneros</SelectItem>
            <SelectItem value={Gender.MALE}>
              {getGenderLabel(Gender.MALE)}
            </SelectItem>
            <SelectItem value={Gender.FEMALE}>
              {getGenderLabel(Gender.FEMALE)}
            </SelectItem>
            <SelectItem value={Gender.MIXED}>
              {getGenderLabel(Gender.MIXED)}
            </SelectItem>
          </SelectContent>
        </Select>
      )}

      {/* Sort Options */}
      <Select value={sortBy} onValueChange={setSortBy}>
        <SelectTrigger className="w-full sm:w-[200px]">
          <SelectValue placeholder="Ordenar por" />
        </SelectTrigger>
        <SelectContent>
          {Object.values(SortOption).map((option) => (
            <SelectItem key={option} value={option}>
              {getSortLabel(option)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
